
import { AppBar, Container, Toolbar, Box, List } from '@mui/material'

import { ListItemPerfil } from './ListItemPerfil'

import { DialogTokenExpired } from '../dialogs/DialogTokenExpired'

export const NavBar = () => {
    
    return (
        <>
            <DialogTokenExpired />
        
            <AppBar position='fixed' style={{ boxShadow: 'none', backgroundColor: 'white', borderBottom: '3px solid rgba(10, 25, 45, 0.8)' }}>

                <Container maxWidth='xl' sx={{ backgroundColor: 'white' }}>

                    <Toolbar 
                        disableGutters
                        sx={{ backgroundColor: 'white', height: 85 }}
                    >
                    
                        <Box sx={{ width: 200, textAlign: 'center' }}>               

                            <img 
                                style={{ height: 60 }}
                                src={ process.env.PUBLIC_URL + '/assets/logo-saji.png'}
                                alt='logo'
                            />                       
                            
                        </Box>  

                        <Box sx={{ flex: 1 }}>

                        </Box>                  

                        <Box sx={{ display: 'flex' }}>
                            
                            <List component='nav'>

                                <ListItemPerfil /> 

                            </List>

                        </Box>                  

                    </Toolbar>

                </Container>

            </AppBar>
        </>
    )
}